<template>
    <img
        v-if="media.id"
        :src="media.thumb"
        :srcset="media.srcset"
        :alt="title"
        :title="title"
        loading="lazy"
        class="max-h-128 object-scale-down"
        width="700px"
        onload="window.requestAnimationFrame(function(){if(!(size=getBoundingClientRect().width)){return;}onload=null;sizes=Math.ceil(size/window.innerWidth*100)+'vw';});"
        :sizes="size"
    />
    <default-photo v-else-if="type !== ''" :type="type" :alt="title"></default-photo>
</template>

<script>
    import DefaultPhoto from '@/components/DefaultPhoto.vue';

    export default {
        name: 'ResponsiveImage',
        components: {
            DefaultPhoto,
        },
        mixins: [],
        props: {
            media: {
                type: Object,
                default: () => ({}),
            },
            title: {
                required: true,
                type: String,
            },
            type: {
                required: true,
                type: String,
            },
            size: {
                type: String,
                default: '150px',
            },
        },
        data() {
            return {};
        },
        methods: {},
    };
</script>
